/* My Development — full-screen, role-aware. Identify via name + PIN; the worker decides:
     store_manager : full team roster (everyone in the store), each with READ-ONLY induction
                     progress (sign-off is Area-Manager only) and a Review button -> review form.
     everyone else : own induction (read-only) + own finalised reviews.
   Review form: scale explained once; store/attendance pulled (placeholder until wired);
   only the human-judgment competencies are scored 1-5; comments; SMART objectives.
   Self-contained overlay (no nav/clock machinery touched); PIN in memory only, wiped on close. */
(function(){
  function fresh(){ return { staffId:null, staffName:null, pin:null, reviewPeople:[], teamInduction:[], reviews:[], reviewing:null, reviewScores:{}, reviewComps:null, reviewingId:null, cycle:null, quarter:null, inductionRows:[], myReviews:[], reviewContext:null, isManager:false, tab:'induction', reviewQuarter:null, scoreQuarter:null, scorecards:{}, scoreDocs:{}, scoreTop50:{}, isAreaManager:false, multiStore:false, selectedStore:null, amStores:[], scoreOnly:false, devStatus:null, devObjectives:null, scoreTraining:undefined, myScore:undefined }; }   // scoreTraining: v132.3 weekly-training line
  var state = fresh();
  function overlay(){ return document.getElementById('myDevOverlay'); }
  function body(){ return document.getElementById('myDevBody'); }
  function esc(s){ return (window.escapeHtml ? window.escapeHtml(s) : String(s==null?'':s)); }
  function workerBase(){ return (typeof DB!=='undefined' && DB.workerUrl) ? DB.workerUrl() : ''; }
  function wrap(inner){ return '<div style="max-width:640px;margin:0 auto;padding:16px 16px 40px">' + inner + '</div>'; }

  function allStaff(){ return (typeof ALL_STAFF!=='undefined' && ALL_STAFF) ? ALL_STAFF : (window.ALL_STAFF || []); }
  function curStore(){
    if (state && (state.isAreaManager || state.multiStore) && state.selectedStore) return state.selectedStore;
    if (typeof currentStore!=='undefined' && currentStore) return currentStore;
    if (typeof currentUser!=='undefined' && currentUser && currentUser.store) return currentUser.store;
    return '';
  }
  // Area managers sign into the index app with their account (Bearer token), not a PIN.
  function amToken(){
    try { return (typeof window!=='undefined' && window.adminToken) ? window.adminToken
               : (typeof adminToken!=='undefined' ? adminToken : null); } catch(e){ return null; }
  }
  function isAreaUser(){
    try { return typeof currentUser!=='undefined' && currentUser && (currentUser.role==='area_manager' || currentUser.role==='admin') && !!amToken(); }
    catch(e){ return false; }
  }
  // One auth shape for every protected POST: Bearer for an area manager (the worker scopes
  // to their area + the store they pass), PIN body for a store manager / sales assistant.
  function mydevPost(extra){
    var h = { 'Content-Type':'application/json' };
    if (state.isAreaManager){ h['Authorization'] = 'Bearer ' + amToken(); return { headers:h, body: JSON.stringify(extra||{}) }; }
    return { headers:h, body: JSON.stringify(Object.assign({ auth_staff_id: state.staffId, auth_pin: state.pin }, extra||{})) };
  }
  // Review roster scoped to the store the AM has selected (their dropdown); SM = own store only.
  function peopleInScope(){
    var p = (state.reviewPeople||[]).slice();
    if ((state.isAreaManager || state.multiStore) && state.selectedStore) p = p.filter(function(x){ return x.store === state.selectedStore; });
    return p;
  }
  // v133.116: a store manager who also manages this store (staff.also_manages) appears here too, so they
  // can sign in on this store's device. The server decides what they may see, never this list.
  function storeStaff(){
    var store = curStore();
    return allStaff().filter(function(s){
      if (s.active===false) return false;
      return s.store===store || (Array.isArray(s.alsoManages) && s.alsoManages.indexOf(store)!==-1);
    })
      .sort(function(a,b){ return String(a.name).localeCompare(String(b.name)); });
  }

  var SCALE_KEY = '1 Unsatisfactory \u00b7 2 Needs Improvement \u00b7 3 Meets \u00b7 4 Exceeds \u00b7 5 Outstanding';
  var SA_SCORED = ['Customer service','Product knowledge','Teamwork','Standards & compliance'];
  var SM_EXTRA  = ['Team leadership','People development','Operational compliance','Commercial management'];
  function isManagerRole(role){ return String(role||'').toLowerCase().indexOf('manager') !== -1; }
  function scoredFor(role){ return isManagerRole(role) ? SA_SCORED.concat(SM_EXTRA) : SA_SCORED.slice(); }
  function roleLabel(role){
    return ({ sales_assistant:'Sales Assistant', store_manager:'Store Manager', area_manager:'Area Manager', retail_relief_manager:'Retail Relief Manager' }[role]) || role || '';
  }
  function currentQuarter(){ var d = new Date(Date.now() + 4*3600*1000); return d.getUTCFullYear() + '-Q' + (Math.floor(d.getUTCMonth()/3) + 1); }
  function currentCycle(){ var d = new Date(Date.now() + 4*3600*1000); return String(d.getUTCFullYear()); }
  function nextQuarter(q){ var m = String(q||'').match(/^(\d{4})-Q([1-4])$/); if(!m) return q; var y=Number(m[1]), n=Number(m[2]); if(n===4){ y++; n=1; } else n++; return y+'-Q'+n; }
  function prevQuarter(q){ var m = String(q||'').match(/^(\d{4})-Q([1-4])$/); if(!m) return q; var y=Number(m[1]), n=Number(m[2]); if(n===1){ y--; n=4; } else n--; return y+'-Q'+n; }
  function moduleArray(r){ return [1,2,3,4,5,6].map(function(n){ return !!r['m'+n+'_date']; }); }
  function qLabel(q){ var m = String(q||'').match(/^(\d{4})-Q([1-4])$/); return m ? ('Q' + m[2] + ' ' + m[1]) : String(q||''); }
  function initials(name){ var p = String(name||'').trim().split(/\s+/); return (((p[0]||'')[0]||'') + ((p[1]||'')[0]||'')).toUpperCase(); }

  window.openMyDevelopment = function(opts){
    opts = opts || {};
    state = fresh();
    overlay().classList.add('open');
    if (isAreaUser()) { startAreaManager(opts); return; }
    // KPI -> Scorecard deep-link: the scorecard is store-level data (add-on
    // achievement + Top 50, both unauthenticated store GETs), so a store login
    // doesn't need the name+PIN picker. Induction/Review stay PIN-gated: they are
    // only reachable via the "Develop" nav (no opts.tab), which still picks+PINs.
    if (opts.tab === 'scorecard' && curStore()) { startStoreScorecard(opts); return; }
    renderPicker();
  };
  window.closeMyDevelopment = function(){ overlay().classList.remove('open'); state = fresh(); body().innerHTML = ''; };

  // ---- store-scoped scorecard entry: no picker, no PIN, scorecard tab only ----
  // isManager stays false, which gates OUT the manager-only Docs card both in the
  // render (scorecardDataInner) and the load trigger (afterPaint) -> /api/store-docs
  // is never called, so no auth is needed. The two visible sections come from
  // unauthenticated store GETs (kpi_comparison, store-top50).
  function startStoreScorecard(opts){
    state.isManager = false;
    state.scoreOnly = true;
    state.staffName = curStore();
    state.tab = 'scorecard';
    renderShell();
  }

  // ---- area-manager entry: no PIN, Bearer identity, multi-store via a dropdown ----
  function startAreaManager(opts){
    opts = opts || {};
    state.isAreaManager = true; state.isManager = true;
    state.staffName = (typeof currentUser!=='undefined' && currentUser && currentUser.name) ? currentUser.name : 'Area Manager';
    body().innerHTML = wrap('<div style="padding:44px;text-align:center;color:var(--learn-grey)">Loading your stores\u2026</div>');
    var base = workerBase();
    var rr = mydevPost({});   // Bearer; review-roster returns everyone in the AM's area
    fetch(base + '/api/review-roster', { cache: 'no-store', method:'POST', headers: rr.headers, body: rr.body })
      .then(function(res){ if (res.status === 401 || res.status === 403){ renderError('Your account isn\u2019t set up for this view.'); return null; } return res.ok ? res.json() : { people:[], reviews:[] }; })
      .then(function(roster){
        if (!roster) return;
        state.reviewPeople = (roster && roster.people) || [];
        state.reviews = (roster && roster.reviews) || [];
        var stores = [];
        state.reviewPeople.forEach(function(p){ if (p.store && stores.indexOf(p.store)===-1) stores.push(p.store); });
        stores.sort();
        state.amStores = stores;
        // honour a deep-link target store if it's in scope, else default to the first
        state.selectedStore = (opts.store && stores.indexOf(opts.store) !== -1) ? opts.store : (stores[0] || null);
        if (!state.selectedStore){ renderError('No stores with staff found for your area yet.'); return; }
        state.tab = (opts.tab && ['induction','review','scorecard'].indexOf(opts.tab) !== -1) ? opts.tab : 'induction';
        reloadInduction(function(){ renderShell(); });
      })
      .catch(function(){ renderError('Couldn\u2019t load your stores - try again'); });
  }
  // (Re)load the selected store's induction. team-induction is server-scoped: SM = own store
  // (store ignored), AM/HO = the store passed (validated against the AM's area).
  function reloadInduction(done){
    var rq = mydevPost({ store: curStore() });
    fetch(workerBase() + '/api/team-induction', { cache: 'no-store', method:'POST', headers: rq.headers, body: rq.body })
      .then(function(res){ return res.ok ? res.json() : []; })
      .then(function(rows){ state.teamInduction = Array.isArray(rows) ? rows : []; if (done) done(); })
      .catch(function(){ state.teamInduction = []; if (done) done(); });
  }
  window.__mydevSetStore = function(store){
    if (!store || store === state.selectedStore) return;
    state.selectedStore = store;
    state.reviewing = null;
    state.scorecards = {}; state.scoreDocs = {}; state.scoreTop50 = {}; state.scoreTraining = undefined;   // per-store caches reset
    state.dm = undefined;   // v133.16: the Duty Manager list is per store too
    reloadInduction(function(){ renderShell(); });
  };

  // ---- entry: picker + PIN ----
  function renderPicker(){
    var rows = storeStaff().map(function(s){
      return '<button class="mydev-name" translate="no" onclick="window.__mydevPick(\'' + s.id + '\')">' + esc(s.name) + '</button>';
    }).join('') || '<div style="padding:24px;text-align:center;color:var(--learn-grey)">No staff found for this store.</div>';
    body().innerHTML = wrap('<div style="font-size:13px;color:var(--learn-grey);margin-bottom:12px">Tap your name to continue.</div>' +
      '<div style="display:flex;flex-direction:column;gap:8px">' + rows + '</div>');
  }
  window.__mydevPick = function(id){
    var s = allStaff().find(function(x){ return String(x.id)===String(id); });
    if(!s) return;
    state.staffId = s.id; state.staffName = s.name; renderPin('');
  };
  function renderPin(errMsg){
    body().innerHTML = wrap('<div style="text-align:center;padding-top:18px">' +
      '<div translate="no" style="font-size:17px;font-weight:700;color:var(--text);margin-bottom:4px">' + esc(state.staffName) + '</div>' +
      '<div style="font-size:13px;color:var(--learn-grey);margin-bottom:18px">Enter your PIN</div>' +
      '<input id="mydevPin" type="password" inputmode="numeric" autocomplete="off" maxlength="6" ' +
        'style="width:180px;padding:12px;border:1px solid var(--border);border-radius:10px;font-size:22px;text-align:center;letter-spacing:6px;background:var(--input-bg)" ' +
        'onkeydown="if(event.key===\'Enter\'){event.preventDefault();window.__mydevSubmit();}">' +
      (errMsg ? '<div style="color:var(--danger);font-size:13px;margin-top:12px">' + esc(errMsg) + '</div>' : '') +
      '<div style="margin-top:22px;display:flex;gap:10px;justify-content:center">' +
        '<button onclick="window.__mydevBack()" style="padding:11px 18px;border:1px solid var(--border);background:var(--card);border-radius:10px;font-size:14px;cursor:pointer">Back</button>' +
        '<button onclick="window.__mydevSubmit()" style="padding:11px 24px;border:none;background:#009E3D;color:#fff;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer">View</button>' +
      '</div></div>');
    setTimeout(function(){ var p=document.getElementById('mydevPin'); if(p)p.focus(); }, 80);
  }
  window.__mydevBack = function(){ renderPicker(); };
  function renderError(msg){
    body().innerHTML = wrap('<div style="padding:40px 0;text-align:center"><div style="color:var(--danger);font-size:14px">' + esc(msg) + '</div>' +
      '<div style="margin-top:18px"><button onclick="window.__mydevBack()" style="padding:11px 20px;border:1px solid var(--border);background:var(--card);border-radius:10px;cursor:pointer">Back</button></div></div>');
  }

  window.__mydevSubmit = function(){
    var el = document.getElementById('mydevPin'); var pin = el ? el.value : '';
    if(!pin || pin.length < 4){ renderPin('Enter your PIN'); return; }
    state.pin = pin;
    body().innerHTML = wrap('<div style="padding:44px;text-align:center;color:var(--learn-grey)">Loading\u2026</div>');
    var base = workerBase();
    var authBody = JSON.stringify({ auth_staff_id: state.staffId, auth_pin: pin });
    fetch(base + '/api/team-induction', { cache: 'no-store', method:'POST', headers:{'Content-Type':'application/json'}, body: authBody })
      .then(function(res){
        if (res.status === 401){ renderPin('Incorrect PIN - try again'); return null; }
        if (res.status === 200){
          return res.json().then(function(induction){
            state.teamInduction = induction || [];
            state.isManager = true;
            return fetch(base + '/api/review-roster', { cache: 'no-store', method:'POST', headers:{'Content-Type':'application/json'}, body: authBody })
              .then(function(rr){ return rr.ok ? rr.json() : { people:[], reviews:[] }; })
              .then(function(roster){
                state.reviewPeople = (roster && roster.people) || [];
                state.reviews = (roster && roster.reviews) || [];
                state.tab = 'induction';
                // v133.116: a manager of more than one store (staff.also_manages) gets the store
                // picker, starting on this device's store; the server sent the stores they may act for.
                var mine = (roster && Array.isArray(roster.stores)) ? roster.stores : [];
                if (mine.length > 1){
                  var here = curStore();
                  state.multiStore = true;
                  state.amStores = mine.slice();
                  state.selectedStore = mine.indexOf(here) !== -1 ? here : mine[0];
                  reloadInduction(function(){ renderShell(); });   // the first load was their home store's
                  return;
                }
                renderShell();
              });
          });
        }
        if (res.status === 403){
          state.isManager = false;
          return fetch(base + '/api/my-induction', { cache: 'no-store', method:'POST', headers:{'Content-Type':'application/json'}, body: authBody })
            .then(function(r2){
              if (r2.status === 401){ renderPin('Incorrect PIN - try again'); return null; }
              if (!r2.ok){ renderError('Could not load (error ' + r2.status + ')'); return null; }
              return r2.json().then(function(rows){
                state.inductionRows = rows || [];
                return fetch(base + '/api/my-reviews', { cache: 'no-store', method:'POST', headers:{'Content-Type':'application/json'}, body: authBody })
                  .then(function(r3){ return r3.ok ? r3.json() : []; })
                  .then(function(revs){
                    // v123.30: response is { reviews, context } now; tolerate the old bare-array
                    // shape too (older Worker / test mocks) so this degrades cleanly.
                    var d = revs || [];
                    state.myReviews = Array.isArray(d) ? d : (d.reviews || []);
                    state.reviewContext = Array.isArray(d) ? null : (d.context || null);
                    state.tab = 'induction'; renderShell();
                    // v129.30 — the person's own development status + objectives.
                    // Fired AFTER the shell paints and never awaited: this screen
                    // already works without it, and an un-migrated project (no
                    // v183-0) must not stop somebody reading their induction.
                    fetch(base + '/api/my-development', { cache:'no-store', method:'POST', headers:{'Content-Type':'application/json'}, body: authBody })
                      .then(function(rd){ return rd.ok ? rd.json() : null; })
                      .then(function(dev){
                        if (!dev || !dev.ok) return;
                        state.devStatus = dev.status || null;
                        state.devObjectives = dev.objectives || [];
                        if ((state.devObjectives && state.devObjectives.length) || state.devStatus) renderShell();
                      })
                      .catch(function(){ /* best-effort: never blocks the page */ });
                  })
                  .catch(function(){ state.myReviews = null; state.reviewContext = null; state.tab = 'induction'; renderShell(); });
              });
            });
        }
        renderError('Could not load (error ' + res.status + ')');
      })
      .catch(function(){ renderError('Connection error - try again'); });
  };


  // ---- v129.30: your development status + objectives (promotion matrix ph2) ----
  // Decision 1, transparency: "One to Watch" is motivating if you know; it is a
  // secret list if you do not. So the person sees their own status and their own
  // objectives here, in their own app, under their own PIN.
  //
  // The manager's private assessment note is NOT here and never arrives — the
  // Worker drops it in publicStatus() before the response is built, so this
  // screen could not show it even if it tried.
  //
  // Managers see their own too (this is their page as much as anyone's); it
  // renders above the team roster rather than instead of it.
  var DEV_STATUS_LABEL = { one_to_watch: 'One to Watch', ready: 'Ready' };
  var DEV_STATUS_BLURB = {
    one_to_watch: 'Your area manager has put you on the development pathway. The objectives below are what you are working towards.',
    ready: 'You have been assessed as ready for the next step.',
  };
  function developmentBlock(){
    var st = state.devStatus, objs = state.devObjectives || [];
    if (!st && !objs.length) return '';
    var open = objs.filter(function(o){ return o.state === 'open'; });
    var done = objs.filter(function(o){ return o.state === 'met'; });
    // Dubai is UTC+4. This file builds every date from getUTC* parts off a
    // +4h-shifted instant (see currentQuarter and the scorecard window) — one
    // convention, and a guard test enforces it by scanning the source text, so
    // do not name the forbidden API here either.
    // It matters: a UTC "today" would mark an objective due TODAY as overdue
    // for the last four hours of every day, on the page belonging to the
    // person it is about.
    var dn = new Date(Date.now() + 4*3600*1000);
    var p2 = function(n){ return n<10 ? '0'+n : ''+n; };
    var today = dn.getUTCFullYear() + '-' + p2(dn.getUTCMonth()+1) + '-' + p2(dn.getUTCDate());

    var head = st
      ? '<div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap">' +
          '<span style="background:#0a84ff;color:#fff;border-radius:999px;padding:3px 12px;font-size:13px;font-weight:800">' +
            esc(DEV_STATUS_LABEL[st.status] || st.status) + '</span>' +
          (st.set_by_name ? '<span style="font-size:12px;color:var(--learn-grey)">set by ' + esc(st.set_by_name) + '</span>' : '') +
        '</div>' +
        '<div style="font-size:13.5px;color:var(--text);line-height:1.5;margin-top:8px">' +
          esc(DEV_STATUS_BLURB[st.status] || '') + '</div>'
      : '<div style="font-size:15px;font-weight:800;color:var(--text)">Your objectives</div>';

    var list = open.length
      ? open.map(function(o){
          var overdue = o.target_date && o.target_date < today;
          return '<div style="display:flex;gap:9px;align-items:flex-start;padding:10px 0;border-top:1px solid var(--border)">' +
            '<div style="flex-shrink:0;width:18px;height:18px;border-radius:50%;border:2px solid #0a84ff;margin-top:2px"></div>' +
            '<div style="flex:1">' +
              '<div translate="no" style="font-size:14px;line-height:1.5;color:var(--text)">' + esc(o.text) + '</div>' +
              '<div style="font-size:12px;color:' + (overdue ? 'var(--ui-warn)' : 'var(--learn-grey)') + ';margin-top:3px">' +
                (o.target_date ? (overdue ? 'was due ' + esc(o.target_date) : 'by ' + esc(o.target_date)) : 'no date set') +
                (o.set_by_name ? ' · ' + esc(o.set_by_name) : '') +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('')
      : '<div style="font-size:13.5px;color:var(--learn-grey);padding:10px 0;border-top:1px solid var(--border)">Nothing open right now.</div>';

    var achieved = done.length
      ? '<div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border);font-size:12.5px;color:var(--learn-grey)">' +
        '<b style="color:var(--text)">' + done.length + ' already met:</b> ' +
        '<span translate="no">' + done.map(function(o){ return esc(o.text); }).join(' · ') + '</span></div>'
      : '';

    return '<div style="background:var(--card);border:1px solid var(--border);border-radius:14px;padding:16px;margin:14px 0 0">' +
      head + list + achieved +
      '<div style="margin-top:12px;font-size:12px;color:var(--learn-grey);line-height:1.5">' +
        'Talk to your manager about any of this — it is meant to be a conversation, not a list handed to you.' +
      '</div>' +
    '</div>';
  }

  // ---- v133.16: the Duty Manager sign-off (src/worker/dm-signoff.js, routes/dm-signoff.js) ----
  // Under the induction. The nine modules are signed by the Area Manager or Head Office in admin;
  // here the person confirms with their own PIN once all nine are signed, and their store manager
  // signs next. Shown only to people someone has started signing off (and their managers).
  function dmLoad(){
    state.dm = null;   // loading
    var rq = state.isManager ? mydevPost({ store: curStore() }) : mydevPost({});
    fetch(workerBase() + (state.isManager ? '/api/team-dm-signoff' : '/api/my-dm-signoff'), { cache:'no-store', method:'POST', headers: rq.headers, body: rq.body })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){ state.dm = d || false; dmPaint(); })
      .catch(function(){ state.dm = false; dmPaint(); });
  }
  function dmPaint(){ var el = document.getElementById('mydevDmBlock'); if (el) el.innerHTML = dmBlock(); }
  function dmTick(sig, label){
    return '<span style="display:inline-block;margin:2px;padding:3px 9px;border-radius:999px;font-size:12px;font-weight:600;' +
      (sig ? 'background:var(--gp);color:var(--ok-deep)">&#10003; ' : 'background:var(--surface-3);color:var(--learn-grey)">') + esc(label) + '</span>';
  }
  function dmFinals(s){
    return dmTick(s.finals.final_employee, 'Employee') + dmTick(s.finals.final_store_manager, 'Store Manager') + dmTick(s.finals.final_area, 'Area Manager or HR');
  }
  function dmBlock(){
    var d = state.dm;
    if (!d || !d.ready) return '';
    var card = 'background:var(--card);border:1px solid var(--border);border-radius:14px;padding:16px;margin:14px 0 0';
    var head = '<div style="font-size:15px;font-weight:800;color:var(--text);margin-bottom:6px">Duty Manager sign-off</div>';
    if (!state.isManager){
      var s = d.signoff;
      if (!s || (!s.signedModules && !s.finals.final_employee)) return '';
      var mods = (d.modules || []).map(function(m){ return dmTick(s.modules[m[0]], m[1]); }).join('');
      var ready = s.signedModules === s.total && !s.finals.final_employee;
      return '<div style="' + card + '">' + head +
        '<div style="font-size:13px;color:var(--text);margin-bottom:8px">' + s.signedModules + ' of ' + s.total + ' modules signed off by your Area Manager' + (s.complete ? ' &middot; <b style="color:var(--ok-deep)">fully signed off</b>' : '') + '</div>' +
        '<div>' + mods + '</div><div style="font-size:12px;color:var(--learn-grey);margin:10px 0 4px">Final certification</div><div>' + dmFinals(s) + '</div>' +
        (ready ? '<div style="margin-top:12px;font-size:13px;color:var(--text);line-height:1.5">I confirm that I have fully completed the Duty Manager Sign Off and am confident I can act as Duty Manager in any ALGT store.</div>' +
          '<button onclick="window.__mydevDmConfirm()" style="margin-top:10px;padding:11px 18px;border:none;background:#009E3D;color:#fff;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer">Confirm with my PIN</button>' : '') +
        '<div id="dmMsg" style="font-size:12px;margin-top:8px;min-height:14px"></div></div>';
    }
    var people = (d.people || []).filter(function(p){ return p.signoff && (p.signoff.signedModules || p.signoff.finals.final_employee); });
    var canSign = !state.isAreaManager;   // a store manager on the till; area managers sign in admin
    var rows = people.map(function(p){
      var s = p.signoff;
      var ok = canSign && s.signedModules === s.total && s.finals.final_employee && !s.finals.final_store_manager && String(p.id) !== String(state.staffId);
      return '<div style="padding:10px 0;border-top:1px solid var(--border)">' +
        '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline"><b translate="no" style="font-size:14px;color:var(--text)">' + esc(p.name) + '</b>' +
        '<span style="font-size:12px;color:var(--learn-grey)">' + s.signedModules + ' of ' + s.total + ' modules</span></div>' +
        '<div style="margin-top:4px">' + dmFinals(s) + '</div>' +
        (ok ? '<button onclick="window.__mydevDmSign(' + Number(p.id) + ')" style="margin-top:8px;padding:9px 14px;border:none;background:#009E3D;color:#fff;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer">Sign as Store Manager</button>' : '') +
        '</div>';
    }).join('');
    return '<div style="' + card + '">' + head +
      '<div style="font-size:12px;color:var(--learn-grey);margin-bottom:6px">Modules are signed off by the Area Manager or Head Office. Then the person confirms, ' + (canSign ? 'you sign as Store Manager, ' : 'the Store Manager signs, ') + 'and the Area Manager or HR Manager signs last.</div>' +
      (rows || '<div style="font-size:13px;color:var(--learn-grey)">No one in this store is working towards the Duty Manager sign-off yet.</div>') +
      '<div id="dmMsg" style="font-size:12px;margin-top:8px;min-height:14px"></div></div>';
  }
  function dmMsg(t, bad){ var m = document.getElementById('dmMsg'); if (m){ m.style.color = bad ? 'var(--danger)' : '#009E3D'; m.textContent = t; } }
  function dmPost(path, extra){
    var rq = mydevPost(extra || {});
    return fetch(workerBase() + path, { cache:'no-store', method:'POST', headers: rq.headers, body: rq.body })
      .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(d){ if (!r.ok) throw new Error(d.error || ('Error ' + r.status)); return d; }); });
  }
  window.__mydevDmConfirm = function(){
    dmPost('/api/my-dm-signoff/confirm').then(function(){ dmLoad(); }).catch(function(e){ dmMsg(e.message, true); });
  };
  window.__mydevDmSign = function(id){
    dmPost('/api/team-dm-signoff/sign', { staff_id: Number(id) }).then(function(){ dmLoad(); }).catch(function(e){ dmMsg(e.message, true); });
  };

  // ---- shell: header + tab bar + content ----
  // v136.46: My score (the Scorecard, Phase 2), for a person signed in with their own PIN; an area manager uses Admin, Scorecard
  var TABS = [['induction','Induction'],['review','Review'],['scorecard','Scorecard'],['myscore','My score']];
  function tabBar(){
    if (state.scoreOnly) return '';   // store-scoped scorecard: no Induction/Review to switch to
    return '<div style="display:flex;background:var(--learn-track);border-radius:11px;padding:3px;margin:14px 0 4px">' + TABS.filter(function(t){ return t[0] !== 'myscore' || (!state.isAreaManager && !!state.staffId); }).map(function(t){
      var on = (state.tab === t[0]);
      return '<div onclick="window.__mydevTab(\'' + t[0] + '\')" style="flex:1;text-align:center;cursor:pointer;font-size:14px;font-weight:' + (on?'800':'600') + ';padding:8px 0;border-radius:8px;' + (on?'background:var(--learn-pill);box-shadow:0 1px 2px rgba(0,0,0,.12);color:var(--text)':'color:var(--learn-grey)') + '">' + t[1] + '</div>';
    }).join('') + '</div>';
  }
  function shellHeader(){
    if (state.scoreOnly){
      return '<div style="font-size:28px;font-weight:800;color:var(--text);letter-spacing:-0.5px">' + esc(curStore()) + '</div>' +
        '<div style="font-size:13px;color:var(--learn-grey);margin-top:4px">Store scorecard</div>';
    }
    if (state.isManager){
      if ((state.isAreaManager || state.multiStore) && state.amStores && state.amStores.length){   // v133.116: or a manager of two stores
        return '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;flex-wrap:wrap">' +
          '<div style="font-size:28px;font-weight:800;color:var(--text);letter-spacing:-0.5px">Your team</div>' +
          '<select onchange="window.__mydevSetStore(this.value)" style="margin-top:6px;padding:9px 12px;border:1px solid var(--border);border-radius:10px;font-size:14px;font-weight:700;color:var(--text);background:var(--input-bg);font-family:inherit;cursor:pointer">' +
            state.amStores.map(function(s){ return '<option value="' + esc(s) + '"' + (s===state.selectedStore?' selected':'') + '>' + esc(s) + '</option>'; }).join('') +
          '</select>' +
        '</div>';
      }
      return '<div style="font-size:28px;font-weight:800;color:var(--text);letter-spacing:-0.5px">Your team</div>' +
        '<div style="font-size:13px;color:var(--learn-grey);margin-top:4px">' + esc(curStore()) + '</div>';
    }
    return '<div translate="no" style="font-size:28px;font-weight:800;color:var(--text);letter-spacing:-0.5px">' + esc(state.staffName) + '</div>' +
      '<div style="font-size:13px;color:var(--learn-grey);margin-top:4px">My development</div>';
  }
  function tabInner(){
    if (state.tab === 'induction') return developmentBlock() + '<div id="mydevInductionBlock">' + inductionTabContent() + '</div>' + '<div id="mydevDmBlock">' + dmBlock() + '</div>';   // v133.16
    if (state.tab === 'review')    return reviewTabContent();
    if (state.tab === 'myscore')   return '<div id="mydevMyScore">' + myScoreView(state.myScore) + '</div>';   // v136.46
    return '<div id="scorecardBody">' + scorecardInner() + '</div>';
  }
  function afterPaint(){
    if (state.tab === 'induction' && !state.scoreOnly && state.dm === undefined) dmLoad();   // v133.16
    if (state.isManager && state.tab === 'review' && state.reviewing) loadReviewContext(state.reviewing);
    if (state.tab === 'myscore' && state.myScore === undefined) loadMyScore();   // v136.46
    if (state.tab === 'scorecard'){
      if (!state.scoreQuarter) state.scoreQuarter = currentQuarter();
      if (state.scorecards[state.scoreQuarter] === undefined) loadScorecard(state.scoreQuarter);
      if (state.scoreTop50[state.scoreQuarter] === undefined) loadScoreTop50(state.scoreQuarter);
      if (state.scoreTraining === undefined) loadScoreTraining();   // v132.3
      if (state.isManager && state.scoreDocs[state.scoreQuarter] === undefined) loadScoreDocs(state.scoreQuarter);
    }
  }
  function renderShell(){
    if (!state.tab) state.tab = 'induction';
    body().innerHTML = wrap(shellHeader() + tabBar() + '<div id="mydevTabContent">' + tabInner() + '</div>');
    afterPaint();
  }
  function paintTabContent(){
    var el = document.getElementById('mydevTabContent'); if(!el) return;
    el.innerHTML = tabInner();
    afterPaint();
  }
  window.__mydevTab = function(tab){
    state.tab = tab;
    if (tab !== 'review') state.reviewing = null;
    renderShell();
  };

  // ---- shared leaf renderers ----
  function moduleChips(r){
    // v129.50 — each module is a designed roundel now (one hue + glyph per
    // module, greyed with its number until passed): progress you can SEE
    // filling in. The old tick squares stay as the fallback when the Artwork
    // bundle has not loaded.
    var art = (typeof Artwork !== 'undefined' && Artwork.moduleRoundel) ? Artwork.moduleRoundel : null;
    return '<div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:12px">' + moduleArray(r).map(function(ok,i){
      if (art) { try { return art(i, ok, 34); } catch (e) { /* fall through */ } }
      return ok
        ? '<span style="width:30px;height:30px;border-radius:9px;background:#009E3D;color:#fff;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700">\u2713</span>'
        : '<span style="width:30px;height:30px;border-radius:9px;background:var(--learn-track);color:var(--learn-faint);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700">' + (i+1) + '</span>';
    }).join('') + '</div>';
  }
  function ring(done){
    var C = 276.46, off = (C * (1 - (done/6))).toFixed(1);
    return '<svg width="104" height="104" viewBox="0 0 104 104" role="img" aria-label="' + done + ' of 6 modules complete">' +
      '<circle cx="52" cy="52" r="44" fill="none" style="stroke:var(--learn-track)" stroke-width="11"></circle>' +
      '<circle cx="52" cy="52" r="44" fill="none" stroke="#009E3D" stroke-width="11" stroke-linecap="round" stroke-dasharray="' + C + '" stroke-dashoffset="' + off + '" transform="rotate(-90 52 52)"></circle>' +
      '<text x="52" y="50" text-anchor="middle" font-size="24" font-weight="800" style="fill:var(--text)">' + done + '/6</text>' +
      '<text x="52" y="66" text-anchor="middle" font-size="11" font-weight="600" style="fill:var(--learn-grey)">modules</text></svg>';
  }
  function indMini(ind){
    if(!ind) return '<div style="font-size:12px;color:var(--learn-grey)">No induction record</div>';
    var done = moduleArray(ind).filter(Boolean).length;
    return '<div><div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:4px"><span style="color:var(--learn-grey);font-weight:600">Induction</span><span style="font-weight:800">' + done + '/6</span></div>' +
      '<div style="height:6px;background:var(--learn-track);border-radius:4px;overflow:hidden"><div style="width:' + Math.round(done/6*100) + '%;height:100%;background:#009E3D"></div></div></div>';
  }
  function yearToggle(years, sel){
    return '<div style="display:flex;background:var(--learn-track);border-radius:9px;padding:2px">' + years.map(function(y){
      var on = (String(y) === String(sel));
      return '<div onclick="window.__mydevSetCycle(\'' + y + '\')" style="cursor:pointer;font-size:13px;font-weight:' + (on?'700':'600') + ';padding:4px 14px;border-radius:7px;' + (on?'background:var(--learn-pill);box-shadow:0 1px 2px rgba(0,0,0,.12);color:var(--text)':'color:var(--learn-grey)') + '">' + esc(String(y)) + '</div>';
    }).join('') + '</div>';
  }

  // ---- INDUCTION TAB ----
  function inductionBody(r){
    var done = moduleArray(r).filter(Boolean).length;
    var pill = r.m1_date
      ? '<span style="background:var(--gp);color:var(--ok-deep);font-size:12px;font-weight:800;padding:6px 12px;border-radius:20px">\u2605 Bonus eligible</span>'
      : '<span style="background:var(--warn-bg);color:var(--warn-deep);font-size:12px;font-weight:800;padding:6px 12px;border-radius:20px">Module 1 pending</span>';
    return '<div style="display:flex;align-items:center;gap:18px">' + ring(done) +
      '<div style="flex:1;min-width:0">' + moduleChips(r) + pill + '</div></div>';
  }
  function inductionEmpty(year){
    return '<div style="padding:18px 4px;color:var(--learn-grey);font-size:13px">No induction record for ' + esc(year) + '.</div>';
  }
  function normName(s){ return String(s==null?'':s).trim().replace(/\s+/g,' ').toLowerCase(); }
  // Match a roster person to an induction/review row. staff_ref (emp_code) is the
  // strong key, but induction rows are often seeded by name with staff_ref still
  // null ("attached on match" later) — so fall back to a normalised name compare,
  // otherwise every card reads "No induction record".
  function indMatch(person, r){
    if (person.emp_code && r.staff_ref && String(r.staff_ref) === String(person.emp_code)) return true;
    return !!(r.staff_name && person.name && normName(r.staff_name) === normName(person.name));
  }
  // v123.26: a REAL induction cycle is a fiscal-year range like "25-26" / "26-27".
  // Stray labels ("Cycle 2") must never appear in the picker — they leaked in from
  // old data and even became the default. The admin People board filters the same way.
  function isYearCycle(c){ return /^\d{2}-\d{2}$/.test(String(c || '')); }
  function inductionYears(rows){
    // Only the REAL fiscal-year cycles present in the data (e.g. "26-27", "25-26").
    var ys = [];
    (rows || []).forEach(function(r){ var c = String(r.cycle); if (c && isYearCycle(c) && ys.indexOf(c) === -1) ys.push(c); });
    return ys.sort(function(a,b){ return String(b).localeCompare(String(a)); });
  }
  function defaultCycle(rows){
    var cy = currentCycle();
    var have = (rows || []).map(function(r){ return String(r.cycle); }).filter(isYearCycle);
    if (have.indexOf(cy) !== -1) return cy;            // current year has data → use it
    have.sort(function(a,b){ return String(b).localeCompare(String(a)); });
    return have[0] || cy;                              // else newest cycle present (so records show)
  }
  function inductionBlock(){
    var rows = state.inductionRows || [];
    if (!state.cycle) state.cycle = defaultCycle(rows);
    var years = inductionYears(rows);
    var row = rows.filter(function(r){ return String(r.cycle) === String(state.cycle); })[0] || null;
    return '<div style="background:var(--card);border-radius:18px;padding:16px;margin-top:14px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">' +
        '<div style="font-size:17px;font-weight:800;color:var(--text)">Induction</div>' + yearToggle(years, state.cycle) + '</div>' +
      (row ? inductionBody(row) : inductionEmpty(state.cycle)) + '</div>';
  }
  function inductionForCycle(person, cycle){
    return (state.teamInduction || []).filter(function(r){ return indMatch(person, r) && String(r.cycle) === String(cycle); })[0] || null;
  }
  function teamInductionCard(person, ind){
    return '<div style="background:var(--card);border-radius:18px;padding:16px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="display:flex;align-items:center;gap:11px;margin-bottom:12px">' +
        '<div style="width:38px;height:38px;border-radius:50%;background:#009E3D;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14px">' + esc(initials(person.name)) + '</div>' +
        '<div><div translate="no" style="font-size:15px;font-weight:700;color:var(--text)">' + esc(person.name) + '</div>' +
          '<div style="font-size:12px;color:var(--learn-grey)">' + esc(roleLabel(person.role)) + '</div></div></div>' +
      indMini(ind) + '</div>';
  }
  function teamInductionBlock(){
    if (!state.cycle) state.cycle = defaultCycle(state.teamInduction);
    var years = inductionYears(state.teamInduction);
    var people = peopleInScope().sort(function(a,b){ return String(a.name).localeCompare(String(b.name)); });
    var cards = people.length
      ? people.map(function(p){ return teamInductionCard(p, inductionForCycle(p, state.cycle)); }).join('')
      : '<div style="padding:24px;text-align:center;color:var(--learn-grey)">No staff in your store yet.</div>';
    return '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:14px">' +
        '<div style="font-size:15px;font-weight:700;color:var(--text)">Induction \u00b7 ' + esc(state.cycle) + '</div>' + yearToggle(years, state.cycle) + '</div>' +
      '<div style="font-size:12px;color:var(--learn-grey);margin-top:4px">Read-only \u2014 your Area Manager signs modules off.</div>' +
      cards;
  }
  function inductionTabContent(){
    return state.isManager ? teamInductionBlock() : inductionBlock();
  }
  window.__mydevSetCycle = function(y){ state.cycle = String(y); var el = document.getElementById('mydevInductionBlock'); if(el) el.innerHTML = inductionTabContent(); };

  // ---- REVIEW TAB (SA self-view) ----
  function barColor(v){ v = Number(v)||0; return v>=4 ? '#009E3D' : (v>=3 ? '#C58F00' : '#DD3333'); }
  function reviewSelfCard(r){
    var comps = r.scores || {};
    var bars = Object.keys(comps).map(function(c){
      var v = Number(comps[c]) || 0;
      return '<div><div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:4px"><span style="color:var(--text);font-weight:600">' + esc(c) + '</span><span style="font-weight:800">' + esc(String(comps[c])) + '</span></div>' +
        '<div style="height:7px;background:var(--learn-track);border-radius:4px;overflow:hidden"><div style="width:' + Math.round(v/5*100) + '%;height:100%;background:' + barColor(v) + '"></div></div></div>';
    }).join('');
    var objs = (Array.isArray(r.objectives) ? r.objectives : []).map(function(o){
      return '<div style="display:flex;gap:8px;align-items:flex-start;margin-top:6px"><span style="color:#009E3D;margin-top:1px">\u25CE</span><span translate="no">' + esc(o) + '</span></div>';
    }).join('');
    return '<div style="background:var(--card);border-radius:18px;padding:16px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:14px">' +
        '<div><div style="font-size:13px;color:var(--learn-grey);font-weight:600">Overall</div>' +
        '<div style="font-size:34px;font-weight:800;line-height:1;color:#009E3D">' + (r.overall!=null?esc(String(r.overall)):'\u2014') + '<span style="font-size:16px;color:var(--learn-grey);font-weight:700">/5</span></div></div>' +
        (r.reviewer ? '<div style="font-size:12px;color:var(--learn-grey);text-align:end">Reviewed by<br><span translate="no" style="color:var(--text);font-weight:700">' + esc(r.reviewer) + '</span></div>' : '') + '</div>' +
      '<div style="display:flex;flex-direction:column;gap:11px">' + bars + '</div>' +
      (r.comments ? '<div style="margin-top:14px;font-size:13px;color:var(--text);background:var(--surface-2);border-radius:12px;padding:11px"><span style="font-weight:800">Comments</span><br><span translate="no">' + esc(r.comments) + '</span></div>' : '') +
      (objs ? '<div style="margin-top:10px;font-size:13px;color:var(--text)"><span style="font-weight:800">Objectives</span>' + objs + '</div>' : '') + '</div>';
  }
  function reviewDue(quarter){
    var m = String(quarter).match(/^(\d{4})-Q([1-4])$/); if(!m) return '';
    var months = ['April','July','October','January'];   // Q1->Apr, Q2->Jul, Q3->Oct, Q4->Jan(next yr)
    var y = Number(m[1]), q = Number(m[2]);
    return months[q-1] + ' ' + (q===4 ? (y+1) : y);
  }
  function reviewQuarterStrip(){
    var cur = currentQuarter();
    var qs = [nextQuarter(cur), cur];
    var p = cur; for (var i=0;i<5;i++){ p = prevQuarter(p); qs.push(p); }
    return qs;   // newest (next) first
  }
  function reviewStripSelector(strip, sel, rows){
    return '<div style="display:flex;background:var(--learn-track);border-radius:9px;padding:2px;overflow-x:auto">' + strip.map(function(q){
      var on = (String(q) === String(sel));
      var has = (rows||[]).some(function(r){ return String(r.quarter) === String(q); });
      return '<div onclick="window.__mydevSetQuarter(\'' + q + '\')" style="flex:1 0 auto;text-align:center;cursor:pointer;font-size:12px;font-weight:' + (on?'700':'600') + ';padding:5px 12px;border-radius:7px;white-space:nowrap;' + (on?'background:var(--learn-pill);box-shadow:0 1px 2px rgba(0,0,0,.12);color:var(--text)':'color:var(--learn-grey)') + '">' + esc(qLabel(q)) + (has ? ' <span style="color:#009E3D">\u2022</span>' : '') + '</div>';
    }).join('') + '</div>';
  }
  function reviewDuePlaceholder(q){
    var future = String(q) > String(currentQuarter());
    return '<div style="background:var(--card);border-radius:18px;padding:22px 18px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04);text-align:center">' +
      '<div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:4px">' + (future ? 'Upcoming review' : 'Not yet completed') + '</div>' +
      '<div style="font-size:13px;color:var(--learn-grey)">' + esc(qLabel(q)) + ' review is due ' + esc(reviewDue(q)) + '.</div>' +
      // v133.102: Wafi City, 7 Oct 2026: "doing Q4 2026 ... not showing the options". There are no options on
      // this screen by design: the store manager fills the review in, and it appears here once finished.
      '<div style="font-size:12.5px;color:var(--text);margin-top:8px">Your store manager completes this review with you. It appears here once it is finished.</div></div>';
  }
  // v123.30: staff see their STORE's customer NPS + store-visit RAG for the quarter,
  // above their personal reviews (Matt: "include the NPS and SVR scores"). Aggregate
  // only, and NPS is already store-view-delayed server-side. Reuses npsColor/ragChip/qLabel.
  function storeContextCard(ctx){
    if (!ctx) return '';
    var nps = ctx.nps || {}, svr = ctx.svr || {};
    var nv = nps.nps, nc = npsColor(nv);
    var ragBits = (svr.total)
      ? '<div style="display:flex;gap:8px;margin-top:8px">' + ragChip('Green', svr.green, '#009E3D') + ragChip('Amber', svr.amber, '#C58F00') + ragChip('Red', svr.red, '#DD3333') + '</div>'
      : '<div style="font-size:12px;color:var(--learn-grey);margin-top:6px">No store visit reports yet this quarter.</div>';
    return '<div style="background:var(--card);border-radius:18px;padding:16px;margin-top:14px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="font-size:15px;font-weight:800;color:var(--text)">Your store this quarter</div>' +
      '<div style="font-size:12px;color:var(--learn-grey);margin-bottom:10px">' + esc(ctx.store) + ' · ' + esc(qLabel(ctx.quarter)) + '</div>' +
      '<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:wrap">' +
        '<div style="font-size:13px;color:var(--learn-grey);font-weight:600">Customer NPS</div>' +
        '<div style="font-size:26px;font-weight:800;line-height:1;color:' + nc + '">' + (nv==null ? '–' : (nv>0?'+':'') + nv) + '</div>' +
        (nps.count
          ? '<div style="font-size:12px;color:var(--learn-grey)">avg <b style="color:var(--text)">' + (nps.avg==null?'–':nps.avg) + '</b>/10 · ' + nps.count + ' review' + (nps.count===1?'':'s') + '</div>'
          : '<div style="font-size:12px;color:var(--learn-grey)">No customer reviews yet</div>') +
      '</div>' +
      '<div style="font-size:13px;font-weight:800;color:var(--text);margin:12px 0 2px">Store visit reports</div>' + ragBits +
    '</div>';
  }
  function renderReviewsBlock(){
    var rows = state.myReviews;
    if (rows === null) return '<div style="margin-top:14px;color:var(--danger);font-size:13px">Could not load reviews.</div>';
    var strip = reviewQuarterStrip();
    if (!state.quarter || strip.indexOf(state.quarter) === -1){
      var withRev = strip.filter(function(q){ return (rows||[]).some(function(r){ return String(r.quarter) === String(q); }); });
      state.quarter = withRev[0] || currentQuarter();      // land on latest review, else current
    }
    var sel = (rows||[]).filter(function(r){ return String(r.quarter) === String(state.quarter); })[0] || null;
    // v126.2 — badges earned feed the review conversation (Matt: "any badges
    // awarded in a quarter, can they show in their quarterly performance
    // review?"). The Achievements bundle fills the container async; fully
    // guarded — My Development never depends on it.
    setTimeout(function(){ try { if (typeof Achievements !== 'undefined' && Achievements.renderPersonalBadges) Achievements.renderPersonalBadges(state.staffId, 'mydevBadges'); } catch(e){} }, 0);
    return storeContextCard(state.reviewContext) +
      '<div style="margin-top:14px">' + reviewStripSelector(strip, state.quarter, rows) + '</div>' +
      '<div id="mydevBadges"></div>' +
      (sel ? reviewSelfCard(sel) : reviewDuePlaceholder(state.quarter));
  }
  window.__mydevSetQuarter = function(q){ state.quarter = String(q); var el = document.getElementById('myReviewsSection'); if(el) el.innerHTML = renderReviewsBlock(); };

  // ---- REVIEW TAB (manager) ----
  function reviewFor(person){
    var mine = state.reviews.filter(function(rv){ return indMatch(person, rv); });
    var cur = null; mine.forEach(function(rv){ if(rv.quarter===currentQuarter()) cur = rv; });
    if (cur) return { review: cur };
    return { review: null };
  }
  function teamReviewCard(person){
    var pid = String(person.id);
    var rev = reviewFor(person).review;
    var statusPill = rev
      ? (rev.status==='final'
          ? '<span style="background:var(--gp);color:var(--ok-deep);font-size:11px;font-weight:800;padding:4px 10px;border-radius:20px">Reviewed</span>'
          : '<span style="background:var(--warn-bg);color:var(--warn-deep);font-size:11px;font-weight:800;padding:4px 10px;border-radius:20px">Draft</span>')
      : '<span style="background:var(--surface-3);color:var(--learn-grey);font-size:11px;font-weight:800;padding:4px 10px;border-radius:20px">Not started</span>';
    return '<div style="background:var(--card);border-radius:18px;padding:16px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04);display:flex;align-items:center;justify-content:space-between;gap:12px">' +
      '<div style="display:flex;align-items:center;gap:11px;min-width:0">' +
        '<div style="width:40px;height:40px;border-radius:50%;background:#009E3D;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:15px;flex:0 0 auto">' + esc(initials(person.name)) + '</div>' +
        '<div style="min-width:0"><div translate="no" style="font-size:15px;font-weight:700;color:var(--text)">' + esc(person.name) + '</div>' +
          '<div style="font-size:12px;color:var(--learn-grey)">' + esc(roleLabel(person.role)) + '</div></div></div>' +
      '<div style="display:flex;align-items:center;gap:10px;flex:0 0 auto">' + statusPill +
        '<button onclick="window.__mydevOpenReview(\'' + pid + '\')" style="padding:9px 18px;border:none;background:#009E3D;color:#fff;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap">Review</button></div>' +
    '</div>';
  }
  function teamReviewRoster(){
    var people = peopleInScope().sort(function(a,b){ return String(a.name).localeCompare(String(b.name)); });
    if (!people.length) return '<div style="padding:24px;text-align:center;color:var(--learn-grey)">No staff in your store yet.</div>';
    return '<div style="font-size:12px;color:var(--learn-grey);margin-top:14px">Tap Review for the current quarter, or open someone to view past quarters.</div>' +
      people.map(teamReviewCard).join('');
  }
  function matchPerson(person, rv){ return indMatch(person, rv); }
  function reviewQuartersFor(person){
    var qs = reviewQuarterStrip();
    state.reviews.filter(function(rv){ return matchPerson(person, rv); }).forEach(function(rv){ if(qs.indexOf(rv.quarter) < 0) qs.push(rv.quarter); });
    return qs.filter(function(q,i){ return qs.indexOf(q) === i; }).sort(function(a,b){ return String(b).localeCompare(String(a)); });
  }
  function existingReviewFor(person, quarter){
    return state.reviews.filter(function(rv){ return matchPerson(person, rv) && rv.quarter===quarter; })[0] || null;
  }
  function carryFor(person, quarter){
    var mine = state.reviews.filter(function(rv){ return matchPerson(person, rv) && String(rv.quarter) < String(quarter); });
    mine.sort(function(a,b){ return String(b.quarter).localeCompare(String(a.quarter)); });
    return (mine[0] && mine[0].objectives) || [];
  }
  function reviewQuarterSelector(person){
    var qs = reviewQuartersFor(person);
    return '<div style="display:flex;background:var(--learn-track);border-radius:9px;padding:2px;margin:0 0 14px;overflow-x:auto">' + qs.map(function(q){
      var on = (String(q)===String(state.reviewQuarter));
      return '<div onclick="window.__mydevReviewQuarter(\'' + q + '\')" style="flex:1 0 auto;text-align:center;cursor:pointer;font-size:12px;font-weight:' + (on?'700':'600') + ';padding:6px 12px;border-radius:7px;white-space:nowrap;' + (on?'background:var(--learn-pill);box-shadow:0 1px 2px rgba(0,0,0,.12);color:var(--text)':'color:var(--learn-grey)') + '">' + esc(qLabel(q)) + '</div>';
    }).join('') + '</div>';
  }
  function cardWrap(inner){ return '<div style="background:var(--card);border-radius:14px;padding:14px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' + inner + '</div>'; }
  function fmtNum(n){ return (Number(n)||0).toLocaleString('en-US', { maximumFractionDigits:0 }); }
  function isSMRole(role){ var r = String(role||'').toLowerCase(); return r === 'store_manager' || r === 'retail_relief_manager'; }
  function blendedOf(lines){ var v = lines.map(function(l){ return l.pct; }).filter(function(p){ return p!=null; }); return v.length ? Math.round(v.reduce(function(a,b){ return a+b; }, 0) / v.length * 10) / 10 : null; }
  function ragChip(label, n, color){
    return '<div style="flex:1;text-align:center;background:' + color + '14;border:1px solid ' + color + '55;border-radius:10px;padding:8px 4px">' +
      '<div style="font-size:20px;font-weight:800;color:' + color + '">' + n + '</div>' +
      '<div style="font-size:11px;font-weight:700;color:' + color + '">' + label + '</div></div>';
  }
  function docsInner(docs){
    var logs = (docs && docs.logs) || [];
    var logRows = logs.length ? logs.map(function(l){
      var color = l.missed===0 ? '#009E3D' : (l.missed<=3 ? '#C58F00' : '#DD3333');
      return '<div style="display:flex;justify-content:space-between;align-items:center;font-size:13px;padding:5px 0;border-top:1px solid var(--border)">' +
        '<span style="color:var(--text)">' + esc(l.label) + '</span>' +
        '<span style="font-weight:800;color:' + color + '">' + (l.missed===0 ? '\u2713 none' : (l.missed + ' missed')) + '<span style="color:var(--learn-grey);font-weight:600"> / ' + l.expected + '</span></span></div>';
    }).join('') : '<div style="font-size:12px;color:var(--learn-grey);padding:4px 0">No log types configured.</div>';
    var svr = (docs && docs.svr) || { green:0, amber:0, red:0, total:0 };
    var ragRow = '<div style="display:flex;gap:8px;margin-top:8px">' +
      ragChip('Green', svr.green, '#009E3D') + ragChip('Amber', svr.amber, '#C58F00') + ragChip('Red', svr.red, '#DD3333') + '</div>';
    return '<div style="font-size:13px;font-weight:800;color:var(--text);margin-bottom:2px">Documentation \u2014 logs missed</div>' +
      logRows +
      '<div style="font-size:13px;font-weight:800;color:var(--text);margin:12px 0 2px">Store visit reports</div>' +
      (svr.total ? ragRow : '<div style="font-size:12px;color:var(--learn-grey);padding:4px 0">No submitted reports this quarter.</div>') +
      npsInner(docs && docs.nps);
  }
  // v123.28: customer Net Promoter Score for the quarter, on the store scorecard.
  // nps is \u2212100..100 (%promoters \u2212 %detractors, 9\u201310 promote / 1\u20136 detract), alongside
  // the plain 1\u201310 average. Managers see it; on the same 1-hour store-view delay HO/AM
  // already apply to the feedback tab. Absent (older Worker) \u2192 block simply omitted.
  function npsColor(v){ return v==null ? 'var(--learn-grey)' : (v>=30 ? '#009E3D' : (v>=0 ? '#C58F00' : '#DD3333')); }
  function npsInner(nps){
    var head = '<div style="font-size:13px;font-weight:800;color:var(--text);margin:12px 0 2px">Customer NPS</div>';
    if (!nps || !nps.count) return head + '<div style="font-size:12px;color:var(--learn-grey);padding:4px 0">No customer reviews this quarter.</div>';
    var nv = nps.nps, c = npsColor(nv);
    return head +
      '<div style="display:flex;align-items:baseline;gap:10px">' +
        '<div style="font-size:30px;font-weight:800;line-height:1;color:' + c + '">' + (nv>0?'+':'') + (nv==null?'\u2013':nv) + '</div>' +
        '<div style="font-size:13px;color:var(--learn-grey)">avg <b style="color:var(--text)">' + (nps.avg==null?'\u2013':nps.avg) + '</b>/10 \u00b7 ' + nps.count + ' review' + (nps.count===1?'':'s') + '</div>' +
      '</div>' +
      '<div style="font-size:11px;color:var(--learn-grey);margin-top:3px">' + (nps.promoters||0) + ' promoter' + (nps.promoters===1?'':'s') + ' (9\u201310) \u00b7 ' + (nps.detractors||0) + ' detractor' + (nps.detractors===1?'':'s') + ' (1\u20136)</div>';
  }
  // v133.17 - the Virtual Store figures on the review (Matt, 3 Oct 2026: context only, never scored).
  // Each one is a dash when its part of Shift is not set up yet.
  function vsLines(v){
    if (!v) return '';
    var dash = '&ndash;', pl = function(n, w){ return n + ' ' + w + (n === 1 ? '' : 's'); };
    var ord = function(n){ var s = ['th','st','nd','rd'], v2 = n % 100; return n + (s[(v2 - 20) % 10] || s[v2] || s[0]); };
    var line = function(label, val){ return '<div style="font-size:13px;color:var(--text);margin-bottom:4px"><span style="color:var(--learn-grey)">' + label + ':</span> ' + val + '</div>'; };
    var pts = !v.points ? dash : '<b style="color:var(--text)">' + v.points.total + '</b> Happyland Points' + (v.points.rank ? ' &middot; ' + ord(v.points.rank) + ' of ' + v.points.of + ' in the store' : '');
    var time = !v.time ? dash : (v.time.visits ? pl(v.time.minutes, 'minute') + ' over ' + pl(v.time.visits, 'visit') : 'Not played this quarter');
    var rounds = !v.rounds ? dash : (v.rounds.played ? pl(v.rounds.played, 'round') + ' &middot; best: ' + v.rounds.best.map(function(b){ return esc(b.label) + ' ' + b.correct + '/' + b.total; }).join(', ') : 'No rounds played');
    var quiz = !v.quiz ? dash : v.quiz.passed + ' of ' + v.quiz.of + ' modules passed (evidence: the Area Manager signs off)';
    var dm = !v.dm ? dash : (v.dm.complete ? 'Fully signed off' : (v.dm.signed ? v.dm.signed + ' of ' + v.dm.total + ' modules signed off' + (v.dm.employee ? ', confirmed by them' : '') : 'Not started'));
    return '<div style="margin-top:12px;padding-top:12px;border-top:1px solid var(--border)"><div style="font-size:13px;font-weight:800;color:var(--text);margin-bottom:6px">Virtual Store &middot; this quarter</div>' +
      line('Points', pts) + line('Time', time) + line('Rounds', rounds) + line('Induction quiz', quiz) + line('Duty Manager', dm) + '</div>';
  }
  function contextCard(data){
    if(!data) return cardWrap('<div style="font-size:12px;color:var(--learn-grey)">Could not load performance figures.</div>');
    var snap = data.snapshot || {}, a = data.attendance || {};
    var bc = tierColor(snap.blended);
    var addonLine = (snap.blended!=null)
      ? '<b style="color:' + bc + '">' + snap.blended + '%</b> add-on achievement'
      : 'No add-on targets this quarter';
    var salesLine = (snap.salesPct!=null) ? '<b style="color:var(--text)">' + snap.salesPct + '%</b> to target' : 'No sales target this quarter';
    var lateLine = (a && a.late != null)
      ? a.late + ' late clock-in' + (a.late===1?'':'s') + ' across ' + a.worked + ' shift' + (a.worked===1?'':'s') + ' (>' + a.threshold_min + ' min)'
      : 'No clock data';
    return cardWrap(
      '<div style="font-size:13px;font-weight:800;color:var(--text);margin-bottom:8px">Store scorecard &amp; attendance \u00b7 ' + esc(qLabel(data.quarter)) + ' to date</div>' +
      '<div style="font-size:13px;color:var(--text);margin-bottom:4px"><span style="color:var(--learn-grey)">Add-ons:</span> ' + addonLine + '</div>' +
      '<div style="font-size:13px;color:var(--text);margin-bottom:4px"><span style="color:var(--learn-grey)">Store sales:</span> ' + salesLine + '</div>' +
      '<div style="font-size:13px;color:var(--text)"><span style="color:var(--learn-grey)">Attendance:</span> ' + lateLine + '</div>' +
      vsLines(data.vs) +   // v133.17
      (data.docs ? '<div style="margin-top:12px;padding-top:12px;border-top:1px solid var(--border)">' + docsInner(data.docs) + '</div>' : '') +
      '<div style="font-size:11px;color:var(--learn-grey);margin-top:10px">Pulled automatically: context for your scoring, not itself scored.</div>'
    );
  }
  function loadReviewContext(person){
    if(!document.getElementById('reviewContext')) return;
    var q = state.reviewQuarter;
    var r = quarterRange(q);
    var base = workerBase();
    var ctxReq = mydevPost({ store: person.store, quarter: q, staff_id: person.id });
    var docsReq = mydevPost({ store: person.store, quarter: q });
    var pAddon = fetch(base + '/api/kpi_comparison?from=' + encodeURIComponent(r.from) + '&to=' + encodeURIComponent(r.to), { cache: 'no-store' })
      .then(function(res){ return res.ok ? res.json() : null; }).catch(function(){ return null; });
    var pCtx = fetch(base + '/api/review-context', { cache: 'no-store', method:'POST', headers: ctxReq.headers, body: ctxReq.body })
      .then(function(res){ return res.ok ? res.json() : null; }).catch(function(){ return null; });
    var pDocs = isSMRole(person.role)
      ? fetch(base + '/api/store-docs', { cache: 'no-store', method:'POST', headers: docsReq.headers, body: docsReq.body })
          .then(function(res){ return res.ok ? res.json() : null; }).catch(function(){ return null; })
      : Promise.resolve(null);
    Promise.all([pAddon, pCtx, pDocs]).then(function(arr){
      var kpi = arr[0], ctx = arr[1], docs = arr[2];
      var row = (kpi && kpi.rows ? kpi.rows : []).filter(function(x){ return x.store === person.store; })[0] || null;
      var snapshot = row ? { blended: blendedOf(scorecardLines(row)), salesPct: row.sales_pct } : { blended: null, salesPct: null };
      var e = document.getElementById('reviewContext');
      if(e) e.innerHTML = contextCard({ quarter: q, snapshot: snapshot, attendance: ctx ? ctx.attendance : null, docs: docs, vs: ctx ? ctx.virtual_store : null });
    });
  }
  function setRMsg(text, isErr){ var m = document.getElementById('rmsg'); if(!m) return; m.style.color = isErr ? 'var(--danger)' : '#009E3D'; m.textContent = text; }
  function reviewForm(){
    var person = state.reviewing; if(!person) return teamReviewRoster();
    if (!state.reviewQuarter) state.reviewQuarter = currentQuarter();
    var existing = existingReviewFor(person, state.reviewQuarter);
    var carry = existing ? null : carryFor(person, state.reviewQuarter);
    var comps = scoredFor(person.role);
    var scores = (existing && existing.scores) || {};
    state.reviewScores = {}; comps.forEach(function(c){ if (scores[c] != null) state.reviewScores[c] = Number(scores[c]); });
    state.reviewComps = comps; state.reviewingId = (existing && existing.id) || null;
    var rowsHtml = comps.map(function(c, i){
      var sel = state.reviewScores[c];
      var btns = [1,2,3,4,5].map(function(n){
        var on = String(sel) === String(n);
        return '<button id="rs-' + i + '-' + n + '" onclick="window.__mydevSetScore(' + i + ',' + n + ')" style="flex:1;padding:9px 0;border:none;border-radius:7px;margin:0 1px;font-size:15px;font-weight:700;cursor:pointer;background:' + (on?'#009E3D':'transparent') + ';color:' + (on?'#fff':'var(--learn-grey)') + '">' + n + '</button>';
      }).join('');
      return '<div style="margin-bottom:14px"><div style="font-size:14px;font-weight:600;color:var(--text);margin-bottom:6px">' + esc(c) + '</div><div style="display:flex;background:var(--learn-track);border-radius:9px;padding:2px">' + btns + '</div></div>';
    }).join('');
    var comments = (existing && existing.comments) || '';
    var objSource = (existing && Array.isArray(existing.objectives) && existing.objectives.length) ? existing.objectives : (carry || []);
    var ta = 'width:100%;padding:11px;border:1px solid var(--border);border-radius:12px;font-size:14px;box-sizing:border-box;font-family:inherit;background:var(--input-bg)';
    var card = 'background:var(--card);border-radius:18px;padding:16px;margin-top:14px;box-shadow:0 1px 2px rgba(0,0,0,.04)';
    return '<button onclick="window.__mydevReviewBack()" style="margin-top:14px;padding:8px 14px;border:none;background:var(--learn-track);color:var(--text);border-radius:10px;font-size:13px;font-weight:700;cursor:pointer">\u2190 Team</button>' +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-top:12px">' +
        '<div translate="no" style="font-size:22px;font-weight:800;color:var(--text);letter-spacing:-0.3px">' + esc(person.name) + '</div></div>' +
      '<div style="font-size:13px;color:var(--learn-grey);margin:2px 0 14px">' + esc(roleLabel(person.role)) +
        ((existing && existing.status==='final') ? ' \u00b7 <span style="color:#009E3D;font-weight:700">finalised</span>' : '') +
        ((!existing && carry && carry.length) ? ' \u00b7 objectives carried forward' : '') + '</div>' +
      reviewQuarterSelector(person) +
      '<div style="font-size:12px;color:var(--learn-grey);margin:-8px 0 14px">' + esc(qLabel(state.reviewQuarter)) + ' review \u00b7 due ' + esc(reviewDue(state.reviewQuarter)) + '</div>' +
      '<div id="reviewContext">' + cardWrap('<div style="font-size:12px;color:var(--learn-grey)">Loading store &amp; attendance\u2026</div>') + '</div>' +
      '<div style="' + card + '">' +
        '<div style="background:var(--surface-2);border-radius:12px;padding:10px 12px;margin-bottom:14px;font-size:12px;color:var(--text);line-height:1.6"><b>Scoring 1\u20135:</b> ' + SCALE_KEY + '</div>' +
        rowsHtml +
        '<label style="display:block;font-size:14px;font-weight:700;color:var(--text);margin:6px 0 5px">Comments</label>' +
        '<textarea id="rcomments" rows="3" style="' + ta + '">' + esc(comments) + '</textarea>' +
        '<label style="display:block;font-size:14px;font-weight:700;color:var(--text);margin:16px 0 3px">Objectives for next quarter</label>' +
        '<div style="font-size:12px;color:var(--learn-grey);margin-bottom:6px">Make them <b>SMART</b>: Specific, Measurable, Achievable, Relevant, Time-bound. One per line.</div>' +
        '<textarea id="robjectives" rows="4" placeholder="e.g. Increase add-on rate to 1.4 by end of Q3 through daily link-selling huddles" style="' + ta + '">' + esc(objSource.join('\n')) + '</textarea>' +
      '</div>' +
      '<div id="rmsg" style="font-size:12px;margin-top:12px;min-height:16px"></div>' +
      '<div style="display:flex;gap:10px;margin-top:4px;flex-wrap:wrap">' +
        '<button onclick="window.__mydevSaveReview(\'draft\')" style="flex:1;padding:12px 16px;border:none;background:var(--gp);color:var(--ok-deep);border-radius:12px;font-size:14px;font-weight:700;cursor:pointer">Save draft</button>' +
        '<button onclick="window.__mydevSaveReview(\'final\')" style="flex:1;padding:12px 18px;border:none;background:#009E3D;color:#fff;border-radius:12px;font-size:14px;font-weight:700;cursor:pointer">Finalise</button>' +
      '</div>';
  }
  function reviewTabContent(){
    if (!state.isManager) return '<div id="myReviewsSection">' + renderReviewsBlock() + '</div>';
    if (state.reviewing) return reviewForm();
    return teamReviewRoster();
  }
  window.__mydevOpenReview = function(pid){
    var person = (state.reviewPeople || []).find(function(p){ return String(p.id)===String(pid); });
    if(!person) return;
    state.reviewing = person; state.reviewQuarter = currentQuarter();
    paintTabContent();
  };
  window.__mydevReviewBack = function(){ state.reviewing = null; paintTabContent(); };
  window.__mydevReviewQuarter = function(q){ state.reviewQuarter = String(q); paintTabContent(); };
  window.__mydevSetScore = function(i, n){
    var comps = state.reviewComps; if(!comps) return;
    state.reviewScores[comps[i]] = n;
    for (var k=1; k<=5; k++){
      var b = document.getElementById('rs-' + i + '-' + k); if(!b) continue;
      var on = (k===n);
      b.style.background = on ? '#009E3D' : 'transparent';
      b.style.color = on ? '#fff' : 'var(--learn-grey)';
    }
  };
  window.__mydevSaveReview = function(status){
    var person = state.reviewing; if(!person) return;
    var comps = state.reviewComps || scoredFor(person.role);
    var scores = {};
    comps.forEach(function(c){ if (state.reviewScores[c]) scores[c] = state.reviewScores[c]; });
    if (status === 'final'){
      var missing = comps.filter(function(c){ return !scores[c]; });
      if (missing.length){ setRMsg('Score every line before finalising (' + missing.length + ' left)', true); return; }
    }
    var comments = (document.getElementById('rcomments') || {}).value || '';
    var objText = (document.getElementById('robjectives') || {}).value || '';
    var objectives = objText.split('\n').map(function(s){ return s.trim(); }).filter(Boolean);
    var review = {
      id: state.reviewingId || undefined,
      staff_ref: person.emp_code || null,
      staff_name: person.name,
      store: person.store,
      quarter: state.reviewQuarter,
      scores: scores, comments: comments, objectives: objectives, status: status,
    };
    setRMsg('Saving\u2026', false);
    var sv = mydevPost({ review: review });
    fetch(workerBase() + '/api/review-save', { cache: 'no-store', method:'POST', headers: sv.headers, body: sv.body })
      .then(function(res){ if (res.status === 403) throw new Error('Not allowed'); if (!res.ok) throw new Error('Error ' + res.status); return res.json(); })
      .then(function(saved){
        if (saved && saved.id){ var i=-1; state.reviews.forEach(function(rv,idx){ if(rv.id===saved.id) i=idx; }); if(i>=0) state.reviews[i]=saved; else state.reviews.push(saved); }
        setRMsg(status === 'final' ? 'Finalised \u2713' : 'Draft saved \u2713', false);
        setTimeout(function(){ state.reviewing = null; paintTabContent(); }, 650);
      })
      .catch(function(e){ setRMsg((e && e.message || 'Failed') + ' - try again', true); });
  };

  // ---- SCORECARD TAB (store add-on achievement, reuses /api/kpi_comparison) ----
  function quarterRange(q){
    var m = String(q).match(/^(\d{4})-Q([1-4])$/);
    var pad = function(n){ return n<10 ? '0'+n : ''+n; };
    var y = Number(m[1]), qn = Number(m[2]);
    var from = y + '-' + pad((qn-1)*3 + 1) + '-01';
    var lastMonth = qn*3;                                  // 3,6,9,12
    var lastDay = new Date(Date.UTC(y, lastMonth, 0)).getUTCDate();
    var qEnd = y + '-' + pad(lastMonth) + '-' + pad(lastDay);
    var dn = new Date(Date.now() + 4*3600*1000);
    var today = dn.getUTCFullYear() + '-' + pad(dn.getUTCMonth()+1) + '-' + pad(dn.getUTCDate());
    // v132.97: <= not <. On a quarter's LAST day the quarter is still running
    // (today's sales are not in yet), so it is still "to date". With < the
    // label vanished every 31 Mar / 30 Jun / 30 Sep / 31 Dec, and the
    // my-development test failed CI for everyone on those days.
    var toDate = today <= qEnd;
    return { from: from, to: (toDate ? today : qEnd), quarter: q, toDate: toDate };
  }
  function scoreQuarters(){
    var qs = [currentQuarter()];
    for (var i=0;i<5;i++) qs.push(prevQuarter(qs[qs.length-1]));   // current + 5 prior (~15 months)
    return qs;
  }
  function scoreQuarterSelector(){
    return '<div style="display:flex;background:var(--learn-track);border-radius:9px;padding:2px;margin-top:14px;overflow-x:auto">' + scoreQuarters().map(function(q){
      var on = (String(q)===String(state.scoreQuarter));
      return '<div onclick="window.__mydevScoreQuarter(\'' + q + '\')" style="flex:1 0 auto;text-align:center;cursor:pointer;font-size:12px;font-weight:' + (on?'700':'600') + ';padding:6px 12px;border-radius:7px;white-space:nowrap;' + (on?'background:var(--learn-pill);box-shadow:0 1px 2px rgba(0,0,0,.12);color:var(--text)':'color:var(--learn-grey)') + '">' + esc(qLabel(q)) + '</div>';
    }).join('') + '</div>';
  }
  function scorecardLines(row){
    return [
      { name:'Demo units',    actual: row.actual_demo_units,   target: row.target_demo_units,   pct: row.demo_pct },
      { name:'Batteries',     actual: row.actual_batteries,    target: row.target_batteries,    pct: row.bat_pct },
      { name:'Gift wrap',     actual: row.actual_gift_wrap,    target: row.target_gift_wrap,    pct: row.wrap_pct },
      { name:'Reusable bags', actual: row.actual_reusable_bag, target: row.target_reusable_bag, pct: row.bag_pct },
      { name:'Gift cards',    actual: row.actual_gift_cards,   target: row.target_gift_cards,   pct: row.cards_pct },
    ];
  }
  // v126.41 (Matt: "there are a lot more KPIs there now that are not included") —
  // three more store KPIs shown BELOW the add-on lines and deliberately NOT folded
  // into the add-on score above (they're not "% vs target", so blending would
  // distort it). Fields come from /api/kpi_comparison?extras=1.
  function numOrNull(v){ var n = Number(v); return (v != null && isFinite(n)) ? n : null; }
  function scorecardExtraLines(row){
    var rev = numOrNull(row.review_avg), svr = numOrNull(row.svr_pct);
    // v136.45 (the Scorecard, decision 3): mobiles and emails are two lines, never blended
    var mob = numOrNull(row.mobile_pct), em = numOrNull(row.email_pct);
    var rc = Number(row.review_count) || 0, vc = Number(row.svr_count) || 0, out = Number(row.review_left_out) || 0;
    return [
      { name:'Mobiles captured',    pct: mob, valueTxt: mob==null ? '–' : mob + '%',    sub:'mobile numbers per bill' },
      { name:'Emails captured',     pct: em,  valueTxt: em==null ? '–' : em + '%',      sub:'emails per bill' },
      // v136.45: suspect reviews (the same connection twice in a day and the like) are left out, and say so
      { name:'Customer reviews',    pct: rev==null ? null : rev*10, valueTxt: rev==null ? '–' : rev + '/10', sub: rc + (rc===1?' review':' reviews') + (out ? ' · ' + out + ' suspect left out' : '') },
      // v126.45 (Matt: "for store visit reports, i think it should be total Green,
      // Amber and Red for the quarter") — lead with the RAG counts; the bar still
      // tracks % green so the colour still means "how healthy".
      // v126.47 (Matt: "there should be a compliance KPI for reading of news and
      // actioning of tasks and surveys") — one blended figure, with the three
      // parts underneath so it's obvious which one is dragging.
      { name:'Comms compliance',    pct: numOrNull(row.comms_pct),
        valueTxt: numOrNull(row.comms_pct)==null ? '–' : row.comms_pct + '%',
        sub: (function(){
          var n = numOrNull(row.comms_news), t = numOrNull(row.comms_tasks), s = numOrNull(row.comms_surveys);
          if (n==null && t==null && s==null) return 'news, tasks + surveys';
          return 'news ' + (n==null?'–':n+'%') + ' · tasks ' + (t==null?'–':t+'%') + ' · surveys ' + (s==null?'–':s+'%');
        })() },
      // v132.77 (Matt: Google reviews on the store balanced scorecard). Reviews
      // GAINED this period on the store's Google listing against the target for
      // the period; the rating is context, not scored. A dash until the nightly
      // snapshot has two readings in the period (one reading is a total, not a gain).
      (function(){
        var g = numOrNull(row.google_gained), t = numOrNull(row.google_target), r = numOrNull(row.google_rating);
        return { name:'Google reviews', pct: (g==null || !t) ? null : Math.max(0, Math.round(g / t * 100)),
          valueTxt: g==null ? '–' : ((g > 0 ? '+' : '') + g + ' new'),
          sub: (t ? 'target ' + t + ' this period' : 'real reviews gained') + (r==null ? '' : ' · rating ' + r.toFixed(1)) };
      })(),
      { name:'Store visits (SVR)',  pct: svr,
        valueTxt: vc === 0 ? '–' : (Number(row.svr_green)||0) + 'G · ' + (Number(row.svr_amber)||0) + 'A · ' + (Number(row.svr_red)||0) + 'R',
        sub: vc === 0 ? 'no visits rated' : (vc + (vc===1?' visit' : ' visits') + (svr==null ? '' : ' · ' + svr + '% green')) },
    ];
  }
  function tierColor(p){ if(p==null) return 'var(--learn-faint)'; if(p>=100) return '#009E3D'; if(p>=80) return '#5C8A00'; if(p>=60) return '#C58F00'; return '#DD3333'; }
  function scoreBar(pct){
    var w = pct==null ? 0 : Math.max(0, Math.min(100, pct));
    return '<div style="height:8px;background:var(--learn-track);border-radius:5px;overflow:hidden"><div style="width:' + w + '%;height:100%;background:' + tierColor(pct) + '"></div></div>';
  }
  function scoreLineRow(l){
    var pctTxt = l.pct==null ? '\u2013' : (l.pct + '%');
    return '<div style="margin-bottom:14px">' +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px">' +
        '<span style="font-size:14px;font-weight:600;color:var(--text)">' + esc(l.name) + '</span>' +
        '<span style="font-size:13px"><b style="color:' + tierColor(l.pct) + '">' + pctTxt + '</b> <span style="color:var(--learn-grey)">' + fmtNum(l.actual) + '/' + fmtNum(l.target) + '</span></span></div>' +
      scoreBar(l.pct) + '</div>';
  }
  function scoreExtraRow(l){
    return '<div style="margin-bottom:14px">' +
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:5px">' +
        '<span style="font-size:14px;font-weight:600;color:var(--text)">' + esc(l.name) + '</span>' +
        '<span style="font-size:13px"><b style="color:' + tierColor(l.pct) + '">' + esc(l.valueTxt) + '</b> <span style="color:var(--learn-grey)">' + esc(l.sub) + '</span></span></div>' +
      scoreBar(l.pct) + '</div>';
  }
  function scorecardEmpty(){
    return '<div style="background:var(--card);border-radius:18px;padding:22px 18px;margin-top:14px;box-shadow:0 1px 2px rgba(0,0,0,.04);text-align:center">' +
      '<div style="font-size:15px;font-weight:700;color:var(--text);margin-bottom:4px">No add-on data yet</div>' +
      '<div style="font-size:13px;color:var(--learn-grey)">Once add-on targets and actuals are recorded for ' + esc(curStore()) + ' this quarter, the team scorecard appears here.</div></div>';
  }
  function scorecardView(sc){
    var vals = sc.lines.map(function(l){ return l.pct; }).filter(function(p){ return p!=null; });
    var blended = vals.length ? Math.round(vals.reduce(function(a,b){ return a+b; }, 0) / vals.length * 10) / 10 : null;
    var bc = tierColor(blended);
    var sp = sc.row.sales_pct;
    var ly = (Number(sc.row.last_year_sales) > 0) ? Math.round(Number(sc.row.sales) / Number(sc.row.last_year_sales) * 1000) / 10 : null;
    var lyDelta = (ly != null) ? Math.round((ly - 100) * 10) / 10 : null;
    var lyColor = (lyDelta == null) ? 'var(--learn-grey)' : (lyDelta >= 0 ? '#009E3D' : '#DD3333');
    var lyTxt = (lyDelta == null) ? '' : ((lyDelta >= 0 ? '+' : '') + lyDelta + '%');
    var head = '<div style="background:var(--card);border-radius:18px;padding:18px;margin-top:14px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="font-size:13px;color:var(--learn-grey);font-weight:600">Add-on achievement \u00b7 ' + esc(qLabel(sc.quarter)) + (sc.toDate ? ' to date' : '') + '</div>' +
      '<div style="font-size:40px;font-weight:800;line-height:1.05;color:' + bc + '">' + (blended==null ? '\u2013' : blended + '<span style="font-size:18px;color:var(--learn-grey);font-weight:700">%</span>') + '</div>' +
      '<div style="font-size:12px;color:var(--learn-grey);margin-top:4px">Balanced average across the five add-on lines \u2014 the whole team moves this together.</div>' +
      '<div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border);font-size:12px;color:var(--learn-grey)">' +
        (sp!=null ? 'Store sales: <b style="color:var(--text)">' + sp + '%</b> to target' : 'No sales target this quarter') +
        (ly!=null ? ' &nbsp;\u00b7&nbsp; vs last year: <b style="color:' + lyColor + '">' + lyTxt + '</b>' : '') +
      '</div>' +
      '</div>';
    var lines = '<div style="background:var(--card);border-radius:18px;padding:18px 16px 4px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="font-size:15px;font-weight:800;color:var(--text);margin-bottom:14px">By line</div>' +
      sc.lines.map(scoreLineRow).join('') + '</div>';
    var extra = scorecardExtraLines(sc.row);
    var extras = '<div style="background:var(--card);border-radius:18px;padding:18px 16px 4px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="font-size:15px;font-weight:800;color:var(--text);margin-bottom:2px">Other store KPIs</div>' +
      '<div style="font-size:12px;color:var(--learn-grey);margin-bottom:14px">Not part of the add-on score above — shown for the full picture.</div>' +
      extra.map(scoreExtraRow).join('') + '</div>';
    return head + lines + extras;
  }
  function scoreDocsBody(){
    var d = state.scoreDocs[state.scoreQuarter];
    if (d === undefined) return '<div style="font-size:12px;color:var(--learn-grey)">Loading documentation\u2026</div>';
    if (d === 'error')   return '<div style="font-size:12px;color:var(--danger)">Could not load documentation.</div>';
    return docsInner(d);
  }
  function scoreDocsCard(){
    return '<div style="background:var(--card);border-radius:18px;padding:18px 16px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' + scoreDocsBody() + '</div>';
  }
  function top50Card(){
    var t = state.scoreTop50[state.scoreQuarter];
    var body;
    if (t === undefined)        body = '<div style="font-size:12px;color:var(--learn-grey)">Loading Top 50\u2026</div>';
    else if (t === 'error')     body = '<div style="font-size:12px;color:var(--danger)">Could not load Top 50.</div>';
    else if (!t.weeks_count)    body = '<div style="font-size:12px;color:var(--learn-grey)">No Top 50 reports for this quarter yet.</div>';
    else if (!t.store_matched)  body = '<div style="font-size:13px;color:var(--learn-grey)">This store isn\u2019t named in the Top 50 report yet' +
        (t.biz_avg_zero!=null ? ' \u2014 business average is <b style="color:var(--text)">' + t.biz_avg_zero + '</b> of ' + (t.total||50) + ' lines with zero sales per week.' : '.') + '</div>';
    else {
      var s = t.store_avg_zero, b = t.biz_avg_zero, total = t.total || 50;
      var color = (b==null||s==null) ? 'var(--text)' : (s <= b ? '#009E3D' : (s <= b*1.5 ? '#C58F00' : '#DD3333'));
      var delta = (b!=null && s!=null) ? Math.round((s-b)*10)/10 : null;
      var deltaTxt = (delta==null) ? '' : ((delta<=0 ? '' : '+') + delta + ' vs business avg');
      var deltaColor = (delta==null) ? 'var(--learn-grey)' : (delta<=0 ? '#009E3D' : '#DD3333');
      body = '<div style="display:flex;align-items:baseline;gap:8px">' +
          '<div style="font-size:32px;font-weight:800;line-height:1;color:' + color + '">' + s + '</div>' +
          '<div style="font-size:13px;color:var(--learn-grey)">of ' + total + ' lines with <b style="color:var(--text)">zero sales</b>, avg per week</div></div>' +
        '<div style="font-size:12px;color:var(--learn-grey);margin-top:8px;padding-top:8px;border-top:1px solid var(--border)">' +
          'Business average: <b style="color:var(--text)">' + (b!=null ? b : '\u2013') + '</b>/week' +
          (deltaTxt ? ' \u00b7 <b style="color:' + deltaColor + '">' + deltaTxt + '</b>' : '') + '</div>' +
        '<div style="font-size:12px;color:var(--learn-grey);margin-top:4px">Across ' + t.weeks_count + ' week' + (t.weeks_count===1?'':'s') + ' \u00b7 lower is better \u00b7 latest week: <b style="color:var(--text)">' + (t.latest && t.latest.store_zero!=null ? t.latest.store_zero : '\u2013') + '</b></div>';
    }
    return '<div style="background:var(--card);border-radius:18px;padding:18px;margin-top:12px;box-shadow:0 1px 2px rgba(0,0,0,.04)">' +
      '<div style="font-size:15px;font-weight:800;color:var(--text);margin-bottom:8px">Top 50 not selling</div>' + body + '</div>';
  }
  function scorecardDataInner(){
    var sc = state.scorecards[state.scoreQuarter];
    var addon = (sc === undefined) ? '<div style="padding:34px;text-align:center;color:var(--learn-grey);font-size:13px">Loading store scorecard\u2026</div>'
              : (sc === 'error')   ? '<div style="margin-top:14px;color:var(--danger);font-size:13px">Could not load the scorecard \u2014 try again shortly.</div>'
              : (sc === 'nodata')  ? scorecardEmpty()
              : scorecardView(sc);
    return addon + top50Card() + trainingCard() + (state.isManager ? scoreDocsCard() : '');
  }
  // v132.3 — weekly training on the scorecard (docs/training-plan.md). Store-
  // level numbers from /api/training/store-summary (validated store name,
  // nobody named). Own tolerant fetch like Top 50: a failure leaves the card
  // absent; the flag OFF returns summary:null and the card stays absent too.
  function trainingCard(){
    var t = state.scoreTraining;
    if (t === undefined || t === 'error' || !t) return '';
    var w = t.this_week;
    var line = w
      ? '<div style="display:flex;justify-content:space-between;gap:8px"><span>This week &mdash; ' + esc(w.topic) + '</span><b style="color:' + (w.pct >= 90 ? 'var(--ok)' : w.pct >= 60 ? 'var(--ui-warn)' : 'var(--danger-deep)') + '">' + w.done + '/' + w.total + ' &middot; ' + w.pct + '%</b></div>'
      : '<div style="color:var(--learn-grey)">No session this week yet.</div>';
    var trend = (t.last4 && t.last4.weeks) ? '<div style="font-size:12px;color:var(--learn-grey);margin-top:4px">Last ' + t.last4.weeks + ' week' + (t.last4.weeks === 1 ? '' : 's') + ': ' + t.last4.pct + '% of the team passed</div>' : '';
    return '<div class="card" style="margin-top:12px;padding:12px 14px"><div style="font-weight:700;margin-bottom:6px">&#127891; Weekly training</div>' + line + trend + '</div>';
  }
  // v136.46: the card is drawn by dist/scorecardView.js (src/shared/scorecard-view.js), loaded the first time My score
  // opens (window.__lazyBundle.scorecardView), so the till never pays for it.
  function myScoreView(d){
    if (typeof ScorecardView !== 'undefined' && ScorecardView.myScoreHtml) return ScorecardView.myScoreHtml(d);
    return '<div style="padding:24px;text-align:center;color:var(--learn-grey)">Loading…</div>';
  }
  // v136.46: the last PUBLISHED month's score for the person signed in (POST /api/my-scorecard, their own PIN)
  function loadMyScore(){
    var p = mydevPost();
    var paint = function(){ var el = document.getElementById('mydevMyScore'); if (el) el.innerHTML = myScoreView(state.myScore); };
    if (typeof window !== 'undefined' && typeof window.ensureScreenBundle === 'function') window.ensureScreenBundle('scorecardView', function(){ paint(); });
    state.myScore = null;
    fetch(workerBase() + '/api/my-scorecard', { cache: 'no-store', method: 'POST', headers: p.headers, body: p.body })
      .then(function(res){ return res.json().catch(function(){ return {}; }).then(function(j){ return res.ok ? j : { error: (j && j.error) || 'Could not load your score.' }; }); })
      .then(function(d){ state.myScore = d; paint(); })
      .catch(function(){ state.myScore = { error: 'Could not reach Shift. Check the connection and try again.' }; paint(); });
  }
  // v136.47: a query on a published score (POST /api/my-scorecard/query), then the card reloads with it
  window.__mydevMyScoreQuery = function(){
    var g = function(id){ var el = document.getElementById(id); return el ? el.value : ''; };
    var msg = String(g('scQueryMessage') || '').trim();
    if (msg.length < 10){ alert('Say what looks wrong, in at least 10 characters.'); return; }
    var p = mydevPost({ staff_id: Number(g('scQueryWho')) || undefined, measure_key: g('scQueryMeasure'), message: msg });
    fetch(workerBase() + '/api/my-scorecard/query', { cache: 'no-store', method: 'POST', headers: p.headers, body: p.body })
      .then(function(res){ return res.json().catch(function(){ return {}; }).then(function(j){ if (!res.ok) throw new Error((j && j.error) || 'Could not send it.'); return j; }); })
      .then(function(){ loadMyScore(); })
      .catch(function(e){ alert(e.message || 'Could not send it.'); });
  };
  function loadScoreTraining(){
    if (!curStore()) return;
    fetch(workerBase() + '/api/training/store-summary?store=' + encodeURIComponent(curStore()), { cache: 'no-store' })
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(d){ state.scoreTraining = (d && d.ok) ? (d.summary || null) : 'error'; if (state.tab==='scorecard'){ var el=document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } })
      .catch(function(){ state.scoreTraining = 'error'; });
  }
  function loadScoreTop50(q){
    fetch(workerBase() + '/api/store-top50?store=' + encodeURIComponent(curStore()) + '&quarter=' + encodeURIComponent(q), { cache: 'no-store' })
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(d){ state.scoreTop50[q] = d || 'error'; if (state.tab==='scorecard' && state.scoreQuarter===q){ var el=document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } })
      .catch(function(){ state.scoreTop50[q] = 'error'; if (state.tab==='scorecard' && state.scoreQuarter===q){ var el=document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } });
  }
  function scorecardInner(){
    if (!state.scoreQuarter) state.scoreQuarter = currentQuarter();
    return scoreQuarterSelector() + '<div id="scorecardData">' + scorecardDataInner() + '</div>';
  }
  window.__mydevScoreQuarter = function(q){
    state.scoreQuarter = String(q);
    var b = document.getElementById('scorecardBody'); if(b) b.innerHTML = scorecardInner();   // re-render selector (highlight) + data
    if (state.scorecards[q] === undefined) loadScorecard(q);
    if (state.scoreTop50[q] === undefined) loadScoreTop50(q);
    if (state.scoreTraining === undefined) loadScoreTraining();   // v132.3
    if (state.isManager && state.scoreDocs[q] === undefined) loadScoreDocs(q);
  };
  function loadScoreDocs(q){
    var dv = mydevPost({ store: curStore(), quarter: q });
    fetch(workerBase() + '/api/store-docs', { cache: 'no-store', method:'POST', headers: dv.headers, body: dv.body })
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(d){ state.scoreDocs[q] = d || 'error'; if (state.tab==='scorecard' && state.scoreQuarter===q){ var el=document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } })
      .catch(function(){ state.scoreDocs[q] = 'error'; if (state.tab==='scorecard' && state.scoreQuarter===q){ var el=document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } });
  }
  function loadScorecard(q){
    var r = quarterRange(q);
    // extras=1 asks the backend for the extra store KPIs (data capture / reviews /
    // SVR) shown below the add-on lines. Only this scorecard fetch requests them.
    // store= additionally returns COMMS COMPLIANCE for THIS store only (v126.47).
    var url = workerBase() + '/api/kpi_comparison?extras=1&store=' + encodeURIComponent(curStore()) +
      '&from=' + encodeURIComponent(r.from) + '&to=' + encodeURIComponent(r.to);
    fetch(url)
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(data){
        var rows = (data && data.rows) || [];
        var row = rows.filter(function(x){ return x.store === curStore(); })[0] || null;
        if (!row){ state.scorecards[q] = 'nodata'; }
        else {
          var lines = scorecardLines(row);
          var hasTarget = lines.some(function(l){ return Number(l.target) > 0; });
          state.scorecards[q] = hasTarget ? { row: row, lines: lines, quarter: q, toDate: r.toDate } : 'nodata';
        }
        if (state.tab === 'scorecard' && state.scoreQuarter === q){ var el = document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); }
      })
      .catch(function(){ state.scorecards[q] = 'error'; if (state.tab === 'scorecard' && state.scoreQuarter === q){ var el = document.getElementById('scorecardData'); if(el) el.innerHTML = scorecardDataInner(); } });
  }
})();
